import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const IconFileUpload = props => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <path fillRule="evenodd" d="M9 16h6v-6h4l-7-7-7 7h4zm-4 2h14v2H5z" />
  </SvgIcon>
);

export default IconFileUpload;



// WEBPACK FOOTER //
// ./src/components/icons/IconFileUpload.js